import { Component, OnInit, ViewChild } from '@angular/core';
import { Role } from 'app/infrastructure/model/classes/role.class';
import { SubscriptionsService } from 'app/infrastructure/services/subscriptions.service';
import { SxSubscription } from 'app/infrastructure/model/classes/subscription.class';
import { ChannelsService } from 'app/infrastructure/services/channels.service';
import { RolesService } from 'app/infrastructure/services/roles.service';
import * as _ from 'lodash';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from 'app/infrastructure/services/auth.service';
import { Location } from '@angular/common';
import { Channel } from 'app/infrastructure/model/interfaces/channel.interface';
import { TreeViewComponent } from 'app/helpers/components/treeView/treeView.component';

@Component({
    selector: 'sx-create-rol',
    templateUrl: './create-rol.component.html',
    styleUrls: ['./create-rol.component.css']
})

export class CreateRolComponent implements OnInit {
    role: Role = new Role();
    channels: Channel[] = [];
    backoffices: SxSubscription[] = [];
    selectedNodesData: String[] = [];
    uncheckedNodes: String[] = [];
    securityAttributesData: any;
    searchTerm: String = '';
    codNegocio: string;
    codSubscription: string;
    codProducto: string;
    codRol: string;
    mode: 'create' | 'edit' = 'create';

    isSocUser= false;

    @ViewChild('tree') tree: TreeViewComponent;

    constructor(
        private _subscriptionsService: SubscriptionsService,
        private _channelsService: ChannelsService,
        private _rolesService: RolesService,
        private _router: Router,
        private _location: Location,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService
    ) { }

    ngOnInit(): void {
        this._activatedRoute.params.subscribe((params: Params) => {
            this.codSubscription = params['codsistema'];
            this.codNegocio = params['codnegocio'];
            this.codProducto = params['codproducto'];
            this.codRol = params['codrol'];

            this._subscriptionsService.getSubscriptions().subscribe(s => this.backoffices = s);
            if (this.codNegocio === undefined && this.codSubscription === undefined) {
                this.isSocUser = true;
                this.codSubscription = '*';
                this.codNegocio = '*';
            }
            if (this.codRol) {
                this.mode = 'edit';
                this.getRole();
            } else {
                // This is just to handle proper redirection when the user clics on "Edit" using the breadcrum.
                if (this._router.url.includes('editar')) {
                    this._router.navigate([`../`], { relativeTo: this._activatedRoute });
                } else {
                    this.setBackoffice();
                    this.setBusiness();
                    this.getSecurityAttributes();
                }
            }
        });
    }

    setBackoffice() {
        this.role.systemCode = this.codSubscription;
    }

    setBusiness() {
        this.role.businessCode = this.codNegocio;
    }

    getSecurityAttributes(secAttributes: string[] = null, newMode: boolean = true) {
        const self = this;
        this._rolesService.getSecurityAttributes(secAttributes, null, newMode, this.codSubscription, this.codNegocio)
            .subscribe(
                data => {
                    this.securityAttributesData = data.config;
                    this.selectedNodesData = this.role.profileCategoryIds || [];

                    _.each(data.config, function (node) {
                        const attributeValue = node.key.securityAttributeCode !== '' ? node.key.securityAttributeCode : node.key.securityAttributeFolderId;
                        if (node.state.checked && !_.includes(self.selectedNodesData, attributeValue)) {
                            self.selectedNodesData.push(attributeValue);
                        }
                    });
                }
            );
    }

    sortBussines(prop: string) {
        const sorted = this.channels.sort(((a, b) => 0 - (a.descripcion > b.descripcion ? -1 : 1)));
        // asc/desc
        if (prop.charAt(0) === '-') { sorted.reverse(); }
        return sorted;
    }

    sortBackoffices(prop: string) {
        const sorted = this.backoffices.sort(((a, b) => 0 - (a.descripcion > b.descripcion ? -1 : 1)));
        // asc/desc
        if (prop.charAt(0) === '-') { sorted.reverse(); }
        return sorted;
    }

    submit() {
        const self = this;
        const items = this.tree.getSelected();
        this.role.profileCategoryIds = [];
        this.role.status = '001';
        const secAttrKeys = [];
        _.each(items, function (item) {
            secAttrKeys.push(item);
        });

        let currentUserName = '';
        this._authService.currentUser.map(m => currentUserName = m.name);

        const callToService = self.mode === 'create' ?
        self._rolesService.createRole(self.role, currentUserName, secAttrKeys) :
        self._rolesService.updateRole(self.role, currentUserName, secAttrKeys, this.uncheckedNodes);

        callToService.subscribe(
            data => {
                this._location.back();
            }
        );
    }

    searchTapped() {
        this._rolesService.getSecurityAttributes(this.selectedNodesData, this.searchTerm, true, this.codSubscription, this.codNegocio)
            .subscribe(
                data => {
                    this.securityAttributesData = data.config;
                }
            );
    }

    getRole() {
        const self = this;
        this._rolesService.getRoleByCode(this.codSubscription, this.codNegocio, this.codRol)
            .subscribe(
                role => {
                    this.role = role;
                    // this.setBackoffice();
                    this.setBusiness();
                    this.getSecurityAttributes(this.role.profileCategoryIds, false);

                }
            );
    }

    onTreeNodeExpanded(node: any) {
        const self = this;
        this._rolesService.getSecurityAttributesByFolderId(
            this.selectedNodesData,
            node.key.securityAttributeFolderId, this.mode === 'edit' ? false : true, node.key.isAncestorOfSelectedAttribute, this.codSubscription, this.codNegocio)
            .subscribe(
                data => {
                    _.each(data.config, function (node) {
                        // Aplica solo a los nodos que no son carpetas
                        // Si una carpeta fue destildada antes de ser expandida y luego se expande, destildamos a todos
                        // los descendientes y los sacamos del array de nodos seleccionados.

                        if ((!node.state.checked && !node.key.isAncestorOfSelectedAttribute) ||
                        _.findIndex(self.uncheckedNodes, function(item: any) {
                            return item.securityAttributeFolderId === node.key.parentId;
                        }) !== -1) {
                            node.state.checked = false;
                            const attributeValue = node.key.securityAttributeCode !== '' ? node.key.securityAttributeCode : node.key.securityAttributeFolderId;
                            _.remove(self.selectedNodesData, function (item) {
                                return item === attributeValue;
                            });
                        }
                    });

                    node.append(data.config);
                    this.updateCheckedNodes(data.config);
                }
            );
    }

    onTreeNodeChecked(node: any) {
        // Cuando se chequea un nodo, guardamos su referencia en el array selectedNodesData.
        // En el caso de las carpetas, se guarda el folderId, en caso de los security attributes se guarda el codigo.
        this.selectedNodesData.push(node.key.securityAttributeCode !== '' ? node.key.securityAttributeCode : node.key.securityAttributeFolderId);

        if (node.key.isAncestorOfSelectedAttribute || node.key.securityAttributeCode !== '') {
            // Cuando se chequea un nodo, sea un ancestro de algun secAtt seleccionado o un secAtt, se agrega el nodo al
            // array uncheckedNodes.
            _.remove(this.uncheckedNodes, function (item: any) {
                return item === node.key;
            });
        }
    }

    onTreeNodeUnchecked(node: any) {
        if (this.selectedNodesData.length > 0) {
            // Al deseleccionar un nodo, se elimina del array selectedNodesData
            _.remove(this.selectedNodesData, function (item) {
                if (node.key.securityAttributeCode !== '') {
                    return item === node.key.securityAttributeCode;
                }
                return item === node.key.securityAttributeFolderId;
            });
        }

        // Si se trata de un ancestro de un security attribute seleccionado o de un secAtt, se agrega al array de uncheckedNodes
        // El includes se encarga de que no se dupliquen elementos.
        if ((node.key.isAncestorOfSelectedAttribute || node.key.securityAttributeCode !== '') &&
        !_.includes(this.uncheckedNodes, node.key)) {
            this.uncheckedNodes.push(node.key);
        }
    }

    onTreeNodeRendered(node: any) {
        // Este evento se ejecuta sobre todos los nodos del arbol tanto en la primera carga como en las cargas sucesivas
        // Se encarga de setear el icono de partially checked a todos los ancestros de los nodos seleccionados.
        // Los dos _.includes se utilizan para asegurarse que solo los nodos que se mantuvieron inmutados se vean como
        // "partially checked". De esta forma, si un ancestro es tildado o tildado, se le asigna el icono correspondiente.
        if (node.key.securityAttributeCode === '' && node.key.isAncestorOfSelectedAttribute &&
            !_.includes(this.uncheckedNodes, node.key) &&
            !_.includes(this.selectedNodesData, node.key.securityAttributeFolderId) &&
            !node.state.checked) {
            this.tree.partiallyCheckNode(node);
        }
    }

    updateCheckedNodes(nodes: any) {
        const self = this;
        _.each(nodes, function (node) {
            const attributeValue = node.key.securityAttributeCode !== '' ? node.key.securityAttributeCode : node.key.securityAttributeFolderId;
            // Si se tilda una carpeta que aun no fue expandida y luego se expande esa carpeta, todos sus descendientes apareceran chequeados.
            // Por ende, se agregan al array selectedNodesData.
            if (node.state.checked && !_.includes(self.selectedNodesData, attributeValue)) {
                self.selectedNodesData.push(attributeValue);
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/rol/create-rol/create-rol.component.ts